import { BondRegularPaymentDispatcher } from "../../../Store/Variables";
import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BondRegularPaymentClient } from "../../../../../../../../Wrap/Api/Bonds/BondRegularPayment";

export class BondRegularPaymentAction {
    public static getBondRegularPayment(hierarchyId: string, callback?): void {
        const client = new BondRegularPaymentClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            if (callback) {callback(data);}
            BondRegularPaymentDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
